import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import DealerListing from "../../components/DealerListing";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

//Redux

import * as sessionActions from "../../redux/dealers/actions";
import * as branchActions from "../../redux/branch/actions";
import ToursList from "../../components/ToursList";
import ExperienceList from "../../components/ExperienceList";
import ToursPersonalInformation from "../../components/ToursPersonalInformation";
import AddNewExperience from "../../components/AddNewExperience";
import AddNewTour from "../../components/AddNewTour";
import ExperiecePersonalInfromation from "../../components/ExperiecePersonalInformation";
import AddNewTestimonial from "../../components/AddNewTestimonial";
import TestimonialsList from "../../components/TestimonialsList";
import TestimonialPersonalInfromation from "../../components/TestimonialPersonalInformation";

//Components

class Home extends Component {
  render() {
    let { page } = this.props.match.params;
    switch (page) {
      case "tours":
        return <ToursList />;

      case `experiences`:
        return <ExperienceList />;

      case "tours-edit":
        return <ToursPersonalInformation />;

      case "experiences-edit":
        return <ExperiecePersonalInfromation />;

      case "tours-addNew":
        return <AddNewTour />;

      case "experience-addNew":
        return <AddNewExperience />;

      case "testimonials":
        return <TestimonialsList />;

      case "testimonails-edit":
        return <TestimonialPersonalInfromation />;

      case "testimonials-addNew":
        return <AddNewTestimonial />;

      default:
        return null;
    }
  }
}

export default Home;
